import { AppHelper } from "../appHelper.js"
import { CommonApp, CommonAppProps, Entity } from "../core/components/commonApp.js";
import { Helper } from "../core/util/helper.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import React from "react";
export class Forward extends React.Component<TicketForwardAppProps, any> {
    common = new AppHelper();
    translations: Array<String>;
    isNew = false;
    fSaveEnabled = true;
    fCloseEnabled = true;

    constructor(props) {
        super(props)
        this.common.init(this);
        this.props.dataSources.hotkeyDataSource = [];
        this.props.dataSources.prostatuskeyDataSource = [];
        this.initApp();
    }


    private initApp = () => {
        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Custom, (data) => {
            if (data.cmd == "assignTo" && !Helper.isNullOrEmpty(data.login)) {
                const login = data.login;
                this.handleFieldChange({
                    model: "entity.Hotliner_Key"
                }, `{Benutzer}_${login}`);
            }
        })
    }

    fClose = () => {
        this.common.sheetWrapper.hide();
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    fSave = () => {
        if (this.common.validate()) {
            HTTPService.post<JsonResultClass>("Procedure/Forward", this.props.entity)
                .then(result => {
                    if (result.Code === 0) {
                        this.props.entity.IsNew = false;
                        //NotificationHelper.showSuccessMessage(this.translations["Standard.Msg.SpeichernErfolgreich"]);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    this.common.handlePostSave(result.Code === 0, true);

                    if (Helper.hasValue(this.props.onAfterForward)) {
                        this.props.onAfterForward();
                    }
                });
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
};


export interface TicketForwardAppProps extends CommonAppProps {
    entity: EntityTicketForward;
    onAfterForward: () => void;
    useStatusRights: boolean;
    externalStatusDependsOnTicketType: boolean;
    ticketStatus: string;
    ticketTyp: string;
    dataSources: {
        hotkeyDataSource: Array<any>,
        prostatuskeyDataSource: Array<any>
    };
}
export interface EntityTicketForward extends Entity {
    Hotliner_Key?: string;
    Kommentar?: string;
    ProblemNr?: number;
    Stufe?: number;
    Termin1?: string;
    Vorgangsstatus_Key?: number;
    TicketValid: boolean;
    ValidationMessage: string;
}